import { Backdrop } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import "./spin.css";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

export default function LoadingBackdrop() {
    const classes = useStyles();

    const { isBackdropOpen } = useSelector(({ backdrop }) => backdrop);

    return (
        <div>
            <Backdrop className={classes.backdrop} open={isBackdropOpen}>
                <img style={{ animation: "spin 3s linear infinite" }} src={require("../../assets/logo.png")} width="70" alt="img" />
            </Backdrop>
        </div>
    );
}
